export const MANAGER_PAY_PERIOD_DETAILS = [
  { id: "/", name: "Home" },
  { id: "/clients", name: "Clients" },
  { id: "/clients/:id", name: ":name" },
  { id: "/clients/:id/:payPeriodId", name: ":payPeriodLabel" },
];
